import { Skeleton } from '@/components/ui/skeleton'

export const FilterListSkeleton = () => {
  return (
    <div className='flex flex-col gap-8'>
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className='space-y-4'>
          <Skeleton className='h-5 w-2/3' />
          <div className='space-y-3'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-5/6' />
            <Skeleton className='h-4 w-full' />
          </div>
        </div>
      ))}
    </div>
  )
}

